module.exports = __webpack_public_path__ + "static/media/menu-hamburger.e888a19a.png";